import InputField, { InputFieldProps } from "./InputField";

const padLeftWithZero = (value: number) => value < 10 ? ('0' + value) : value;

export const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  return year + '-' + padLeftWithZero(month) + '-' + padLeftWithZero(day);
};

const isDateFormatValid = (date: string|null) =>
  date === undefined || (date !== null && /^\d{4}-\d{2}-\d{2}$/.test(date) && !isNaN(new Date(date).getTime()));

const getErrorMessage = (date: string|null) =>
  !date || isDateFormatValid(date) ? null : 'Nieprawidłowy format daty (rrrr-mm-dd)';

const DateInputField = (props: InputFieldProps<string>) => {
  return (
    <InputField {...props}
      castToType={text => text}
      convertValueToText={text => text}
      errorMessage={getErrorMessage}
    />
  );
};

export default DateInputField;